/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Device } from '../../models/device';
import { DeviceCreateRequest } from '../../models/device-create-request';

export interface CreateDevice$Params {
      body: DeviceCreateRequest
}

export function createDevice(http: HttpClient, rootUrl: string, params: CreateDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<Device>> {
  const rb = new RequestBuilder(rootUrl, createDevice.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Device>;
    })
  );
}

createDevice.PATH = '/api/v1/devices';
